<template>
    <header ref="head" id="head">
        <div class="mainBox">
            <router-link id="logo" to="/home"><img src="../assets/logo.png" alt="网罗天下" title="网罗天下"></router-link>
            <nav>
                <ul>
                    <li><router-link to="/home"><i></i><span>首页</span></router-link></li>
                    <li><router-link :class="{active:$route.meta.isService}" to="/service/serviceList"><i></i><span>服务</span></router-link></li>
                     <li>
                        <a href="javascript:;"><i></i><span><span class="m-hide">解决</span>方案</span></a>
                        <dl>
                            <dd>
                                <a href="http://cy.wluotx.com/" target="_blank"><span>创新创业综合服务</span></a>
                            </dd>
                            <dd>
                                <a href="http://jkqy.wluotx.com/f/index" target="_blank"><span>智能疫情防控解决方案</span></a>
                            </dd>
                        </dl>
                    </li>
                    <li><router-link :class="{active:$route.meta.isCases}" to="/cases"><i></i><span>案例</span></router-link></li>
                    <li><router-link to="/about"><i></i><span>关于</span></router-link></li>
                    <li>
                        <router-link :class="{active:$route.meta.isCantact}" to="/cantact/cantactMap"><i></i><span>联系</span></router-link>
                        <dl>
                            <dd>
                                <router-link :class="{active:$route.meta.isCantactMap}" to="/cantact/cantactMap">
                                    <span>联系我们</span>
                                </router-link>
                            </dd>
                            <dd>
                                <router-link :class="{active:$route.meta.isCantactRe}" :to="{name:'cantactRecruitment',params:{id:recruittype.length>0?recruittype[0].id:'b27fef26e2cd407086324056a6e22175'}}">
                                    <span>人才招聘</span>
                                </router-link>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    props:['recruittype']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- lang="less"后 可编写less ，默认的cli无less-loader包，需自行安装 -->
<!-- scoped 的作用为限定css的作用域，防止污染 -->
<style scoped lang="less">
#head{
    width: 100%;
    height: 70px;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 0 0 8px 0 rgba(200, 200, 245, 0.5);
    position: fixed;
    top: 0;
    z-index: 1000;
}
#logo{
    display: block;
    padding: 19px 14px;
    height: 70px;
    float: left;
    img{
        height: 100%;
    }
}
nav{
    height: 70px;
    float: right;
    font-size: 14px;
    ul{
        height: 100%;
    }
    li{
        height: 100%;
        text-align: center;
        cursor: pointer;
        float: left;
        position: relative;
        &:hover dl{
            display: block;
        }
        a{
            display: block;
            height: 100%;
            padding: 0 22px;
            &.router-link-exact-active,&:hover,&.active{
                background-color: #cde5ff;
                span{
                    color: #1577e4;
                }
            }
        }
        &:nth-child(1) i{
            background-position: 0px 10px;
        }
        &:nth-child(2) i{
            background-position: -50px 10px;
        }
        &:nth-child(3){
            a{
                padding: 0 12px;
            }
            i{
                margin:0 auto;
                background-position: -235px -204px;
            }
            dl{
                width: 195px;
                right: -50px;
            }
        }
        &:nth-child(4) i{
            background-position: -100px 10px;
        }
        &:nth-child(5) i{
            background-position: -150px 10px;
        }
        &:nth-child(6) {
            i{
                background-position: -200px 10px;
            }
            dl{
                width: 86px;
                right: 0;
            }
        }
    }
    i{
        display: block;
        width: 36px;
        padding-top: 49px;
        background-image: url('../assets/ico/icon.png');
        background-repeat: no-repeat;
    }
    span{
        color: #3f3f3f;
    }
    dl{
        display: none;
        width: 86px;
        background-color: rgba(255, 255, 255, 0.9);
        position: absolute;
        right: 0;
        z-index: 100;
        dd{
            padding: 0 8px;
            &:first-of-type a{
                border-bottom: 1px solid #ced5e0;
            }
            &:hover span{
                color: #1577e4;
            }
            a{
                display: block;
                width: 100%;
                height: 41px;
                line-height: 41px;
                background-color: transparent!important;
                font-size: 14px;
                color: #4e5358;
                padding: 0;
            }
        }
    }
}

@media only screen and (max-width:750px) {
    #head{
        height: 140px;
    }
    nav{
        width: 100%;
        li{
            width: 16.5%;
            text-align: center;
            a{
                display: inline-block;
                width: 100%;
                padding: 0;
            }
        }
        i{
            margin: 0 auto;
        }
    }
    .m-hide{
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mhead.vue